module.exports = __webpack_public_path__ + "img/1ROSEAPPLE.fa7eb0b6.png";